import axios from "@/libs/api.request";

export const getTableData = () => {
  return axios.request({
    url:'get_table_data',
    method:'get'
  })
}

export const errorReq = () =>{
  return axios.request({
    url:'error_url',
    method: 'post'
  })
}

export const saveErrorLogger = info => {
  return axios.request({
    url:'save_error_logger',
    data: info,
    method: 'post'
  })
}

export const getNoUseAccess = () => {
  return axios.request({
    url:'api/accessNumber/noUseSelect',
    method:'get'
  })
};

export const getMusicList = ()=>{
  return axios.request({
    url: 'api/music/select',
    method:'get'
  })
}

export const serverMac = ({auth,timestamp})=>{
  return axios.request({
    url: 'api/sysCommon/systemMac',
    method: 'get',
    params:{timestamp:timestamp},
    headers:{'Authorization':auth}
  })
}

export const getAllDevice = (task_id)=>{
  return axios.request({
    url: '/api/20190821/infs/getConfoExtenList.json',
    method: 'post',
    data: task_id
  })
}

export const webLogo = () => {
  return axios.request({
    url: 'system-service/api-v1.0/sysGeneral/allLogo',
    method: 'get'
  })
}

export const getGeneral = ()=>{
  return axios.request({
    url:'system-service/api-v1.0/sysGeneral/query',
    method:'get'
  })
}

export const getSystemTime = ()=>{
  return axios.request({
    url :'/api/sysCommon/systemTime',
    method: 'get'
  })
}

//修改为已读的
export const updateNoAnswerIsRead = (id) => {
  return axios.request({
    url: '/api/20210119/infs/updateRecordReadStatus.json',
    method: 'get',
    params:{
      id: id
    }
  })
}

//获取系统中分区的数据
export const getSysDept = () => {
  return axios.request({
    url: '/api/20210223/getAllDept.json',
    method:'get'
  })
}

export const getQueueExtens = (queueNum) => {
  return axios.request({
    url: '/api/20210224/infs/getQueueExtensByQueueName.json',
    method: 'get',
    params:{
      queueNum: queueNum
    }
  })
}

/**
 * 生成hostInfo文件
 * @returns {*}
 */
export const generatorHostInfo = ()=>{
  return axios.request({
    url:'/api/sysCommon/resetHostInfo',
    method:'get',
    params:''
  })
}

/**
 * 获取系统中存在的分机类型
 * @param auth
 * @returns {*}
 */
export const getHasExtenType = ({auth})=>{
  return axios.request({
    url: 'api/20210615/infs/getHasExtenType.json',
    method: 'get',
    headers:{'Authorization':auth}
  })
}

export const phoneInfo = ({auth,phone,userId})=>{
  return axios.request({
    url:'api/20210617/infs/getInfoByPhone.json',
    method:'post',
    headers:{'Authorization':auth},
    data:{phone:phone,userId:userId}
  })
}


/**
 * 获取级联分机
 * @param appKey
 * @param grade
 * @returns {*}
 */
export const getGradeExtens = ({appKey, grade}) => {
  const params = {appKey,grade}
  return axios.request({
    url:'system-service/api-v2.0/grade/tree/extens',
    method:'get',
    params
  })
}

/**
 * 获取视频通话的数量
 * @returns {*}
 */
export const getVideoCallCount = () => {
  return axios.request({
    url:'video-service/api-v2.0/monitor/counts',
    method:'get',
  })
}

/**
 * 获取当前系统是否是EPX
 * @returns {*}
 */
export const getSystemType = () => {
  return axios.request({
    url: 'system-service/api-v1.0/sysGeneral/getSystemType',
    method: 'get'
  })
}

/******
 * currDeptId
 */
// 通过当前分区ID 获取所有子集分区ID
export const getDeviceListByUser=(deptId,isAdmin,userDeptId)=>{

  return axios.request({
    url: '/api/api-v2.2.3/20211012/getDeviceListByUser.json',
    data:{
      deptId:deptId,
      isAdmin:isAdmin,
      userDeptId:userDeptId
    },
    method: 'post',
  })
}

//根据userId获取分区以及分机数据。
export const getDeptAndEmpList=(deptId,isAdmin,isOffline,labelIsMail)=>{
  return axios.request({
    url: '/api/20210927/infs/getDepetAndEmpList.json',
    data:{
      deptId:deptId,
      isAdmin:isAdmin,
      isOffline:isOffline,
      labelIsMail:labelIsMail ? labelIsMail : "",
    },
    async: false,
    method: 'post',
  })
}

//根据userId获取主系统以及子系统数据。
export const getSystemLinkList=(deptId,isAdmin,isOffline)=>{
  return axios.request({
    url: '/api/api_v2.2.6/systems/getTreeLinks.json',
    data:{
      deptId:deptId,
      isAdmin:isAdmin,
      isOffline:isOffline,
    },
    method: 'post',
  })
}
//检查系统密码
export const checkPwd=()=>{
  return axios.request({
    url: '/api/checkDefault',
    data:{},
    method: 'post',
  })
}
//更新密码
export const checkPwdValid=({userName,passWord})=>{
  const params = {userName,passWord}
  return axios.request({
    url: '/api/check/checkPwdValid.json',
    params,
    method: 'get',
  })
}

export const downloadFile = async (options={}) =>{
  if (!options.url || !options.method) {
    return
  }
  await axios.request({
    url:options.url,
    params:options.params?options.params:{},
    data:options.data?options.data:{},
    responseType:'blob',
    method:options.method,
    onDownloadProgress(progress){
      let downProgress = Math.round((100*progress.loaded)/progress.total)
      options.callback ? options.callback(downProgress, options.tick ? options.tick : options.name) : null
    },
  }).then(res=>{
    let data = res.data
    let headers = res.headers
    if (!data){
      return
    }
    let url = window.URL.createObjectURL(new Blob([data],{type: headers['content-type']}))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    if (!options.name) {
      const fileName = headers['content-disposition']
      const dname = headers['download-filename']
      let title = headers['filename'] ? headers['filename'] : dname?dname:fileName && fileName.indexOf('filename=')>-1?fileName.split('=')[1]:'downloadFile_'+Date.now()
      if (title.startsWith('"')) {
        title = title.substring(0)
      }
      if (title.endsWith('"')) {
        title = title.substring(title.length-1)
      }
      options.name = decodeURI(title)
    }

    link.setAttribute('download',options.name)
    document.body.appendChild(link)
    link.click()
  }).catch(err=>{
    options.callback ? options.callback(-1, options.tick ? options.tick : options.name) : null
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js